<template>
    <div class="JobView" :data-job-id="job?.id">
        <div v-if="(isVisible || preview)">
            <OpportunityPageLayout
                back-label="Späť na prácu"
                :preview="preview"
                reverse-bottom-style
                :to="{
                    name: 'praca',
                    query: $route.query,
                    hash: `#r-id-${jobSlug}`
                }"
                variant="job"
            >
                <JobViewLayoutTop :job="job" :org="org" :preview="preview" />
                <template #middle>
                    <JobViewLayoutMiddle :job="job" :org="org" :preview="preview" />
                </template>

                <template #left>
                    <JobViewLayoutLeft :job="job" />
                </template>

                <template #right>
                    <JobViewLayoutRight :job="job" :org="org" :preview="preview" />
                </template>
            </OpportunityPageLayout>
        </div>

        <div v-else>
            <NotFound :title="$t('jobView.notFound.title', job?.lang || 'sk')">
                {{ $t('jobView.notFound.text', job?.lang || 'sk') }}
                <br />
                {{ $t('jobView.notFound.showAll', job?.lang || 'sk') }}
                <NuxtLink class="link" :to="{ name: 'praca' }">
                    {{ $t('jobView.notFound.link', job?.lang || 'sk') }}
                </NuxtLink>
                .
            </NotFound>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Job } from '#shared/types/Job'
import type { Org } from '#shared/types/Org'
import { VisibilityType } from '#shared/types/visibility'

interface Props {
    job?: Job
    org?: Org
    preview?: boolean
}

const props = defineProps<Props>()
const route = useRoute()

const jobSlug = computed(() => route.params.slug)
const isVisible = computed(() => props.job?.visibility !== VisibilityType.hidden)
</script>
